module.exports = __webpack_public_path__ + "static/img/np.b66578a5.svg";